module.exports = __webpack_public_path__ + "img/right-circles-png.7306a509.png";